// extracted by mini-css-extract-plugin
export var actionButton = "_l4-0";
export var actionMenuContainer = "_l4-i";
export var bubble = "_l4-2";
export var bubbleActionMenu = "_l4-j";
export var bubbleContext = "_l4-6";
export var bubbleItems = "_l4-7";
export var customer = "_l4-3";
export var divider = "_l4-8";
export var fileList = "_l4-9";
export var hiddenComment = "_l4-o";
export var infoAbove = "_l4-a";
export var internal = "_l4-4";
export var lightActionButton = "_l4-1";
export var link = "_l4-b";
export var merchant = "_l4-5";
export var message = "_l4-c";
export var profilePicture = "_l4-e";
export var quillToolbarContainer = "_l4-f";
export var senderDate = "_l4-g";
export var senderDateCustomer = "_l4-h";
export var senderName = "_l4-d";
export var time = "_l4-k";
export var uploadedImage = "_l4-l";
export var username = "_l4-m";
export var xsmall = "_l4-n";